// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Insider20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Insider20: FC<Insider20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <mask
                id="a"
                width="20"
                height="20"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
            >
                <path d="M0 0h20v20H0z" />
            </mask>
            <g mask="url(#a)">
                <path d="M2.23 12 1 11.125l4-6.5 2.5 3 3.5-5.5 2.5 3.5L16.542 1l1.208.875-4.208 6.396-2.48-3.459-3.395 5.355-2.48-2.98zm9.765 3q.838 0 1.422-.578A1.92 1.92 0 0 0 14 13.005q0-.838-.578-1.422A1.92 1.92 0 0 0 12.005 11q-.838 0-1.422.579A1.92 1.92 0 0 0 10 12.995q0 .838.579 1.422a1.92 1.92 0 0 0 1.416.583m3.943 3-2.042-2.042a3.2 3.2 0 0 1-.899.407q-.483.135-.997.135-1.458 0-2.48-1.02Q8.5 14.457 8.5 13t1.02-2.48Q10.543 9.5 12 9.5t2.48 1.02Q15.5 11.543 15.5 13q0 .514-.135.997a3.2 3.2 0 0 1-.407.899L17 16.937z" />
            </g>
        </svg>
    );
};

export default Insider20;
